module.exports = __webpack_public_path__ + "img/product-shot_02.275c9cdb.jpg";